import React, { useCallback, useMemo } from 'react';

import useForm from '../../../common/utils/hooks/useForm';
import useCreateMutation from './useCreateMutation';

export default function withCreateMutation (WrappedComponent) {
	const ReturnedComponent = (props) => {
		const {
			createMutation,
			onSubmitSuccess,
			history,
			preSubmitFunction,
			initialValues,
			validation,
			offlineConfigKey,
			disableOffline,
		} = props;

		const { createItemFunction, createStatus } = useCreateMutation({
			createMutation,
			offlineConfigKey,
			disableOffline,
		});

		const onCreationSuccess = useMemo(() => getOnCreationSuccess(createMutation, onSubmitSuccess, history), [createMutation, onSubmitSuccess, history]);

		const { submitForm, ...otherFormFunctionality } = useForm(
			initialValues,
			createItemFunction,
			onCreationSuccess,
			undefined,
			validation,
		);

		const { values: form, changeFormValue } = otherFormFunctionality;

		const onSubmit = useCallback(async () => {
			if (preSubmitFunction) {
				await preSubmitFunction({ form, changeFormValue });
			}
			submitForm();
		}, [changeFormValue, form, preSubmitFunction, submitForm]);

		return (
			<WrappedComponent
				{...props}
				{...otherFormFunctionality}
				onSubmit={onSubmit}
				errors={{
					...createStatus.validationErrors,
					...otherFormFunctionality.errors,
				}}
			/>
		);
	};
	return ReturnedComponent;
}

const getOnCreationSuccess = (createMutation, onSubmitSuccess, history) => {
	const operationName = createMutation.definitions[0].selectionSet.selections[0].name.value.toString();

	let onCreationSuccess;

	if (onSubmitSuccess) {
		onCreationSuccess = payload => {
			const newObject = payload.data?.[operationName];
			onSubmitSuccess(newObject, payload);
		};
	}
	else {
		onCreationSuccess = payload => {
			const newObject = payload.data?.[operationName];
			const model = newObject.__typename.toLowerCase();
			const defaultRedirectPath = `/${model}/${newObject.id}`;
			history.push(defaultRedirectPath);
		};
	}

	return onCreationSuccess;
};
